<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="emails">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [showBorders]="true"
            [dataSource]="emails"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <!-- <dxi-column dataField="id" width="40"></dxi-column> -->
            <dxi-column dataField="type" caption="Type" width="120"></dxi-column>
            <dxi-column dataField="invoice.invoiceNumber" caption="Invoice#" width="80"></dxi-column>
            <dxi-column dataField="salesOrder.invoiceNumber" caption="Sales Order #" width="80"></dxi-column>
            <dxi-column dataField="purchaseOrder.pONumber" caption="PO #" width="80"></dxi-column>
            <dxi-column dataField="to" caption="To" width="200"></dxi-column>
            <dxi-column dataField="cc" caption="Cc" width="200"></dxi-column>
            <dxi-column dataField="bcc" caption="Bcc" width="200"></dxi-column>
            <dxi-column dataField="subject" caption="Subject" width="200"></dxi-column>
            <dxi-column dataField="body" caption="Body" width="200"></dxi-column>
            <dxi-column dataField="created" width="200"></dxi-column>
            <dxi-column dataField="createdBy.userName" caption="Created By" width="200"></dxi-column>
            <dxi-column dataField="sent" width="150" dataType="date" format="shortDateShortTime"></dxi-column>


            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="email-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" (click)="toggleShowAll()" class="btn btn-sm btn-warning">{{ showAll ? 'Show Last 500' : 'Show All' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="emails" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
